import { getUserLocale } from '../i18n.service';
import { getOrDelete } from './glosbe-dictionary-api-helper';
export function getLanguages(params) {
    /*
    TODO
        if (this.settingsService.developerTools) {
            params['all'] = true;
        }
        */
    if (!params.locale) {
        params.locale = getUserLocale();
    }
    return getOrDelete({ endpoint: 'languages', params, options: { credentials: 'include' } });
}
